import { IoClose } from "react-icons/io5";
import { connectorList } from "./utils/connector-list";
import DatabaseConnector from "./database-connector";
import DatabaseConnectionList from "./database-connection-list";
import React, { forwardRef } from "react";

interface DatabaseConnectorMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConnectorMenu = forwardRef<HTMLDialogElement, DatabaseConnectorMenuProps>(
  ({ isOpen, onClose }, ref) => {
    return (
      <dialog ref={ref} className="modal backdrop-blur-sm" open={isOpen}>
        <div className="modal-box w-11/12 max-w-4xl">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-bold text-lg">Database Connections</h3>
            <button className="btn btn-ghost btn-circle" onClick={onClose}>
              <IoClose size={18} />
            </button>
          </div>
          <div className="flex flex-col gap-3 mt-5">
            <DatabaseConnectionList />
            <h4 className="text-md font-semibold">Add New Connection</h4>
            <div className="grid grid-cols-3 gap-5 mt-2">
              {connectorList.map((connector, index) => (
                <DatabaseConnector key={index} databaseName={connector.name}>
                  <connector.icon />
                </DatabaseConnector>
              ))}
            </div>
          </div>
        </div>
      </dialog>
    );
  }
);

ConnectorMenu.displayName = "DatabaseConnectorMenu";

export default ConnectorMenu;
